<br><br><br><br><br><br>
<div class="jd-loading" *ngIf="isLoading">
  <div class="skeleton-header">
    <div class="sk sk-logo"></div>
    <div class="sk-body">
      <div class="sk sk-title"></div>
      <div class="sk sk-line short"></div>
      <div class="sk sk-line medium"></div>
    </div>
  </div>
  <div class="sk sk-block"></div>
  <div class="sk sk-block tall"></div>
</div>

<div class="jd-error" *ngIf="!isLoading && hasError">
  <p>{{ 'jobDescription.failedToLoadJobDetails' | translate }}</p>
  <button class="btn-apply" (click)="goBack()">{{ 'jobDescription.backToJobs' | translate }}</button>
</div>

<div class="jd-page" *ngIf="!isLoading && !hasError && job && extras">

  <div class="jd-header-card">
    <div class="jd-header-left">
      <div class="jd-logo" [style.background]="job.companyLogoUrl ? 'transparent' : job.companyColor">
        <img *ngIf="job.companyLogoUrl" [src]="job.companyLogoUrl" [alt]="job.company" class="jd-logo-img" />
        <span *ngIf="!job.companyLogoUrl">{{ job.companyInitial }}</span>
      </div>

      <div class="jd-header-info">
        <h2 class="jd-title">{{ job.title }}</h2>
        <div class="jd-subtitle mt-1" *ngIf="job.positionTitle" style="color: #5E6670; font-size: 15px; font-weight: 500; margin-bottom: 8px;">
          <span>{{ job.positionTitle }}</span>
        </div>
        <div class="jd-meta-row">

          <span class="jd-meta-item">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M6.5 1C4.567 1 3 2.567 3 4.5c0 2.625 3.5 6 3.5 6S10 7.125 10 4.5C10 2.567 8.433 1 6.5 1z"
                stroke="#6b7280" stroke-width="1.2" fill="none" />
              <circle cx="6.5" cy="4.5" r="1.3" fill="#6b7280" />
            </svg>
            {{ job.location }}
          </span>

          <span class="jd-meta-item">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <rect x="1.5" y="4" width="10" height="7.5" rx="1.5" stroke="#6b7280" stroke-width="1.2" />
              <path d="M4.5 4V3a2 2 0 014 0v1" stroke="#6b7280" stroke-width="1.2" />
            </svg>
            {{ job.type }}
          </span>

          <span class="jd-meta-item" *ngIf="job.workplace">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <rect x="1" y="6" width="11" height="6.5" rx="1.2" stroke="#6b7280" stroke-width="1.2" />
              <path d="M3.5 6V5a3 3 0 016 0v1" stroke="#6b7280" stroke-width="1.2" />
              <path d="M1 9h11" stroke="#6b7280" stroke-width="1.2" />
            </svg>
            {{ getWorkplaceLabel(job.workplace) }}
          </span>

          <span class="jd-meta-item" *ngIf="job.department">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <rect x="1" y="4" width="11" height="8" rx="1.2" stroke="#6b7280" stroke-width="1.2" />
              <path d="M4 4V3a2 2 0 014 0v1" stroke="#6b7280" stroke-width="1.2" />
              <path d="M1 7h11" stroke="#6b7280" stroke-width="1.2" />
            </svg>
            {{ job.department }}
          </span>

          <span class="jd-meta-item" *ngIf="!job.hideSalary">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <circle cx="6.5" cy="6.5" r="5.5" stroke="#6b7280" stroke-width="1.2" />
              <path d="M6.5 2.5v8M4.5 4.5c0-1 .9-1.5 2-1.5s2 .5 2 1.5-1 1.5-2 1.5-2 .5-2 1.5.9 1.5 2 1.5 2-.5 2-1.5"
                stroke="#6b7280" stroke-width="1.1" stroke-linecap="round" />
            </svg>
            {{ getSalaryDisplay() }}
          </span>

          <span class="jd-meta-item">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <circle cx="6.5" cy="6.5" r="5.5" stroke="#6b7280" stroke-width="1.2" />
              <path d="M6.5 3.5v3l2 1.5" stroke="#6b7280" stroke-width="1.2" stroke-linecap="round" />
            </svg>
            {{ 'jobDescription.posted' | translate }} {{ job.postedAgo }}
          </span>

          <span class="jd-meta-item" *ngIf="getExperienceLabel()">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <rect x="1" y="3.5" width="11" height="8" rx="1.2" stroke="#6b7280" stroke-width="1.2" />
              <path d="M4 3.5V2.5a2.5 2.5 0 015 0v1" stroke="#6b7280" stroke-width="1.2" />
            </svg>
            {{ getExperienceLabel() }}
          </span>

        </div>
        <div class="jd-tags" *ngIf="extras.tags.length > 0">
          <span class="jd-tag" *ngFor="let tag of extras.tags">{{ tag }}</span>
        </div>
      </div>
    </div>

    <div class="jd-header-actions">
      <div class="jd-action-stack">
        <div class="jd-action-row">
          <button class="btn-apply" (click)="goToApply(job.id)" [disabled]="job.applied"
            [attr.aria-disabled]="job.applied">
            {{ job.applied ? ('jobDescription.applied' | translate) : ('jobDescription.applyNow' | translate) }}
          </button>
          <button class="btn-icon btn-share" (click)="shareJob()" [title]="'jobDescription.share' | translate">
            <svg *ngIf="!shareCopied" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="14" cy="4" r="2" stroke="currentColor" stroke-width="1.4" />
              <circle cx="4" cy="9" r="2" stroke="currentColor" stroke-width="1.4" />
              <circle cx="14" cy="14" r="2" stroke="currentColor" stroke-width="1.4" />
              <line x1="5.9" y1="7.9" x2="12.1" y2="5.1" stroke="currentColor" stroke-width="1.4" />
              <line x1="5.9" y1="10.1" x2="12.1" y2="12.9" stroke="currentColor" stroke-width="1.4" />
            </svg>
            <svg *ngIf="shareCopied" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4 9l4 4 6-6" stroke="#0f9b57" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="share-tooltip" *ngIf="shareCopied">{{ 'jobDescription.linkCopied' | translate }}</span>
          </button>
        </div>
        <p class="apply-hint" *ngIf="job.applied">
          {{ 'jobAppliedHint' | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="jd-body">

    <div class="jd-content">

      <section class="jd-section">
        <h2 class="jd-section-title">{{ 'jobDescription.jobDescription' | translate }}</h2>
        <div class="jd-text mt-1 jd-quill-content" [innerHTML]="extras.description"></div>
      </section>
      <section class="jd-section jd-skill-section" *ngIf="extras.skills.length > 0">
        <div class="jd-section-header">
          <div>
            <h2 class="jd-section-title">{{ 'jobDescription.skills' | translate }}</h2>
            <p class="jd-section-subtitle">{{ 'jobDescription.skillsSubtitle' | translate }}</p>
          </div>
        </div>

        <div class="jd-feature-panel" style="border:none; padding:0; background:transparent; box-shadow:none;">
          <div class="jd-feature-cards">
            <div class="jd-feature-card" *ngFor="let skill of extras.skills">
              <div class="jd-tag">
                <span class="jd-feature-value">{{ skill }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="jd-section" *ngIf="extras.responsibilities.length > 0">
        <h2 class="jd-section-title">{{ 'jobDescription.responsibilities' | translate }}</h2>
        <div class="jd-quill-content" *ngFor="let r of extras.responsibilities" [innerHTML]="r">
        </div>
      </section>

      <section class="jd-section" *ngIf="extras.requirements.length > 0">
        <h2 class="jd-section-title">{{ 'jobDescription.requirements' | translate }}</h2>
        <div class="jd-quill-content" *ngFor="let r of extras.requirements" [innerHTML]="r">
        </div>
      </section>

      <section class="jd-section" *ngIf="extras.benefits.length > 0">
        <h2 class="jd-section-title">{{ 'jobDescription.benefits' | translate }}</h2>
        <div class="benefits-wrapper">
          <div *ngFor="let b of extras.benefits" [innerHTML]="b">
          </div>
        </div>
      </section>

    </div>

    <aside class="jd-sidebar">

      <div class="jd-company-card">
        <div class="company-card-logo" [style.background]="job.companyLogoUrl ? 'transparent' : job.companyColor">
          <img *ngIf="job.companyLogoUrl" [src]="job.companyLogoUrl" [alt]="job.company"
            style="width:100%;height:100%;object-fit:contain;" />
          <span *ngIf="!job.companyLogoUrl" style="font-size:24px;font-weight:700;color:#374151;">{{ job.companyInitial
            }}</span>
        </div>
        <h3 class="company-card-name">{{ job.company }}</h3>
        <p class="company-card-industry" *ngIf="job.confidential; else industryLabel">{{ 'jobDescription.confidentialCompany' | translate }}</p>
        <ng-template #industryLabel>
          <p class="company-card-industry">{{ extras.industry }}</p>
        </ng-template>
        <button class="btn-view-company" *ngIf="!job.confidential" [routerLink]="['/company-profile', job.companyId]">
          {{ 'jobDescription.viewCompany' | translate }}
        </button>
        <div class="company-card-private" *ngIf="job.confidential">
          {{ 'jobDescription.companyProfileHidden' | translate }}
        </div>
      </div>

      <div class="jd-summary-card">
        <h3 class="summary-title">{{ 'jobDescription.jobSummary' | translate }}</h3>

        <div class="summary-item">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M7.5 1C5.015 1 3 3.015 3 5.5c0 3.281 4.5 8.5 4.5 8.5S12 8.781 12 5.5C12 3.015 9.985 1 7.5 1z"
                stroke="#3575e2" stroke-width="1.2" fill="none" />
              <circle cx="7.5" cy="5.5" r="1.5" fill="#3575e2" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.location' | translate }}</p>
            <p class="summary-value">
              {{ job.location }}
              <span *ngIf="job.workplace === 'REMOTE'"> ({{ 'jobDescription.remoteFriendly' | translate }})</span>
            </p>
          </div>
        </div>

        <div class="summary-item">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <rect x="1.5" y="4.5" width="12" height="9" rx="1.5" stroke="#3575e2" stroke-width="1.2" />
              <path d="M5 4.5V3a2.5 2.5 0 015 0v1.5" stroke="#3575e2" stroke-width="1.2" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.jobType' | translate }}</p>
            <p class="summary-value">{{ job.type }}</p>
          </div>
        </div>

        <div class="summary-item" *ngIf="job.workplace">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <rect x="1" y="6" width="13" height="8" rx="1.5" stroke="#3575e2" stroke-width="1.2" />
              <path d="M4 6V4.5a3.5 3.5 0 017 0V6" stroke="#3575e2" stroke-width="1.2" />
              <path d="M1 10h13" stroke="#3575e2" stroke-width="1.2" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.workplace' | translate }}</p>
            <p class="summary-value">{{ getWorkplaceLabel(job.workplace) }}</p>
          </div>
        </div>

        <div class="summary-item" *ngIf="getExperienceLabel()">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <circle cx="7.5" cy="7.5" r="6" stroke="#3575e2" stroke-width="1.2" />
              <path d="M7.5 4v3.5l2 2" stroke="#3575e2" stroke-width="1.2" stroke-linecap="round" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.experience' | translate }}</p>
            <p class="summary-value">{{ getExperienceLabel() }}</p>
          </div>
        </div>

        <div class="summary-item" *ngIf="job.jobLevel">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M2 11h2.5v2H2zM6.25 7.5h2.5v5.5h-2.5zM10.5 4h2.5v9.5h-2.5z" stroke="#3575e2" stroke-width="1.2"
                fill="none" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.level' | translate }}</p>
            <p class="summary-value">{{ job.jobLevel }}</p>
          </div>
        </div>

        <div class="summary-item" *ngIf="!job.hideSalary">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path
                d="M7.5 1v13M5 3.5C5 2.1 6.1 1.5 7.5 1.5S10 2.1 10 3.5 8.9 5.5 7.5 5.5 5 6.5 5 8s1.1 2.5 2.5 2.5S10 9.4 10 8"
                stroke="#3575e2" stroke-width="1.2" stroke-linecap="round" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.salary' | translate }}</p>
            <p class="summary-value">{{ getSalaryFull() }}</p>
          </div>
        </div>

        <div class="summary-item">
          <span class="summary-icon">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <rect x="1.5" y="2.5" width="12" height="11" rx="1.5" stroke="#3575e2" stroke-width="1.2" />
              <path d="M1.5 6.5h12M5 1v3M10 1v3" stroke="#3575e2" stroke-width="1.2" stroke-linecap="round" />
            </svg>
          </span>
          <div>
            <p class="summary-label">{{ 'jobDescription.datePosted' | translate }}</p>
            <p class="summary-value">{{ extras.postedDate }}</p>
          </div>
        </div>

      </div>
    </aside>
  </div>

  <section class="jd-similar-section">
    <h2 class="jd-similar-title">{{ 'jobDescription.similarJobs' | translate }}</h2>
    <div class="jd-similar-grid" *ngIf="similarJobs.length > 0; else noSimilarJobs">
      <div class="jd-similar-card" *ngFor="let j of similarJobs" (click)="goToJob(j.id)">
        <div class="similar-card-header">
          <div class="similar-logo" [style.background]="j.companyLogoUrl ? 'transparent' : j.companyColor">
            <img *ngIf="j.companyLogoUrl" [src]="j.companyLogoUrl" [alt]="j.company" />
            <span *ngIf="!j.companyLogoUrl">{{ j.companyInitial }}</span>
          </div>
          <div>
            <p class="similar-job-title">{{ j.title }}</p>
            <p class="similar-company">{{ j.company }}</p>
          </div>
        </div>
        <div class="similar-meta">
          <span class="similar-meta-item">
            <svg width="12" height="12" viewBox="0 0 13 13" fill="none">
              <path d="M6.5 1C4.567 1 3 2.567 3 4.5c0 2.625 3.5 6 3.5 6S10 7.125 10 4.5C10 2.567 8.433 1 6.5 1z"
                stroke="#9ca3af" stroke-width="1.2" fill="none" />
              <circle cx="6.5" cy="4.5" r="1.3" fill="#9ca3af" />
            </svg>
            {{ j.location }}
          </span>
          <span class="similar-meta-item" *ngIf="!j.hideSalary">
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
              <path
                d="M8 1v14M5 3.5C5 2.1 6.1 1.5 8 1.5S11 2.1 11 3.5 9.9 5.5 8 5.5 5 6.5 5 8s1.1 2.5 3 2.5 3-1.1 3-2.5"
                stroke="#9ca3af" stroke-width="1.2" stroke-linecap="round" />
            </svg>
            {{ getSimilarSalaryLabel(j) }}
          </span>
        </div>
        <div class="similar-tags" *ngIf="getSimilarTags(j).length > 0">
          <span class="jd-tag" *ngFor="let tag of getSimilarTags(j)">{{ tag }}</span>
        </div>
        <button class="btn-view-details" (click)="goToJob(j.id); $event.stopPropagation()">{{ 'jobDescription.viewDetails' | translate }}</button>
      </div>
    </div>
    <ng-template #noSimilarJobs>
      <div class="jd-similar-empty">{{ 'jobDescription.noSimilarJobsAvailable' | translate }}</div>
    </ng-template>
  </section>
</div>

<button class="btn-back" (click)="goBack()">
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
  {{ 'jobDescription.backToJobs' | translate }}
</button>